(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeItemSearch', HandbookMergeItemSearch);

    HandbookMergeItemSearch.$inject = ['$resource'];

    function HandbookMergeItemSearch($resource) {
        var resourceUrl =  'api/_search/handbook-merge-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
